import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  Button,
  MenuItem,
  CardMedia,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useScrollTrigger,
  Slide,
  Badge,
  styled,
  ClickAwayListener,
  Avatar,
  Grid,
  DialogContent,
  Dialog, Accordion, AccordionSummary, AccordionDetails,
} from "@mui/material";

import AdbIcon from "@mui/icons-material/Adb";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import { PrimaryButton, SecondaryButton } from "../../components/Buttons";
import Colors from "../../assests/style";
import { Images, MenuIcon } from "../../assests";
import { Link, useNavigate } from "react-router-dom";
import { auth, provider, signInWithPopup } from "../../config/firebase.config"; // Adjust the import path according to your file structure
import { getAuth, GoogleAuthProvider, signOut } from "firebase/auth";
import AuthServices from "../../services/AuthServices";
import { AuthContext } from "../../Context/AuthContext";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { CartContext } from "../../Context/CartContext";
import Swal from "sweetalert2";
import SignInModal from "../../components/LoginModal";
import OrderServices from "../../services/OrderServices";
import { useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import useGeoLocation from "react-ipgeolocation";
import { getData, getCode } from "country-list";
import LanguageIcon from '@mui/icons-material/Language';
import { getCountryCode } from "../../utils";
import { ExpandMore } from '@mui/icons-material'

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}
const SmallBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    minWidth: "10px",
    height: "10px",
    fontSize: "10px",
    padding: "0",
  },
}));
function Header() {
  const { cartVisible, toggleCartVisibility } = useContext(CartContext);
  let User = localStorage.getItem("user");
  User = JSON.parse(User);
  const location = useLocation();
  const [userData, setUserData] = useState();
  const auth = getAuth();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [currentState, setCurrentState] = useState("login");
  const [dropdown, setDropdown] = useState(false);
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  console.log(user, "useruseruser");
  const [cartData, setCartData] = useState(null);
  const [cartItems, setCartItems] = useState([])
  const [active, setActive] = useState("home");
  const [profile, setProfile] = useState('')
  const [region, setRegion] = useState(false)
  const [code, setCode] = useState('')

  const userProfile = async (sendData) => {
    console.log(sendData, "data");
    try {
      let params = {};
      const { data } = await OrderServices.userProfile(params);
      console.log(data?.details, 'data');
      setProfile(data?.details?.picture)
      setUser(data?.details)

    } catch (error) {
      console.log(error);
    } finally {
    }
  };


  const handleOpenDrawer = (event) => {
    setOpen(event.currentTarget);
  };

  const scrollToId = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getCartData = async (sendData) => {
    console.log(sendData, 'data');
    try {
      let params = {

      }
      const { data } = await OrderServices.CartData(params)
      console.log(data?.cart?.designs);



      setCartItems(data?.cart?.designs)

    } catch (error) {
      console.log(error);
    } finally {

    }
  }

  const handleCloseDrawer = () => {


    setOpen(false);
    setCurrentState("login");
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

    setDropdown(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setDropdown(false);
  };

  const handleProfile = () => {
    // Handle profile click
    console.log("Profile clicked");
    setOpen(false);
    setAnchorEl(null);
    setDropdown(false);
    window.location.href = "/my-account";
    handleClose();
  };

  const pages = [
    { name: "Home", url: "/", id: "home" },
    { name: "Collection", url: "/collections", id: "collections" },
    { name: "Blog", url: "/blogs", id: "blogs" },
    { name: "How it Works", url: "", id: "how-section" },
    // { name: "Pricing", url: "", id: "pricing-section" },
    { name: "Contact Us", url: "/contact-us", id: "contact" },
  ];

  useEffect(() => {
    const currentPath = location.pathname;
    const activePage = pages.find(
      (page) => page.url === currentPath || (!page.url && location.hash.includes(page.id))
    );

    if (activePage) {
      setActive(activePage.id); // Set active to the matching page id
    } else {
      setActive(""); // Clear active state if no match is found
    }
  }, [location]);

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log("User Info: ", user);

      authLogin(user?.reloadUserInfo, result);

      // Handle user info here (e.g., save to state, context, or redirect)
    } catch (error) {
      console.error("Error during Google login: ", error);
    }
  };

  const authLogin = async (sendData, result) => {
    console.log(sendData, "data");
    try {
      let obj = {
        phone: "",
        google_id: sendData.localId,
        email: sendData.email,

        name: sendData.displayName,
      };
      const data = await AuthServices.authLogin(obj);
      console.log(data, 'datadatadatadata');
      if (data?.responseCode == 200) {
        console.log(data);
        localStorage.setItem("authToken", JSON.stringify(data?.data?.token));
        localStorage.setItem("user", JSON.stringify(data?.data?.name));
        let userInfo = localStorage.getItem("user");
        setUserData(JSON.parse(userInfo));
        setUser(result.user);
        getCartData()
      }
    } catch (error) {

    } finally {
    }
  };
  const handleClose2 = () => {
    setCurrentState('login')
    setOpen2(false);
  };

  const generateSession = async (sendData) => {
    console.log(sendData, "data");
    try {
      const { data } = await AuthServices.generateSession();
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleLogout = async () => {
    try {
      localStorage.clear();
      setOpen(false);
      if (location.pathname == '/') {
        window.location.reload()
      }
      else {
        navigate("/");
      }

      let user = localStorage.getItem("user");
      setUserData(JSON.parse(user));
      await signOut(auth);
      console.log("User signed out");

    } catch (error) {
      console.error("Error during sign out: ", error);
    }
  };
  useEffect(() => {
    let user = localStorage.getItem("user");
    setUserData(JSON.parse(user));
    console.log(JSON.parse(user), 'JSON.parse(user)');

    // setUser("");
    generateSession();
    let cartdata = localStorage.getItem("orderData");
    console.log(cartdata);
    if (cartdata) {
      console.log(cartdata, "cartdatacartdata");
      setCartData(cartdata);
      // toggleCartVisibility()
    } else {
      setCartData(null);
    }
    userProfile()
  }, []);
  const handleCloseDropdown = () => {
    setAnchorEl(null);
  };
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    getCartData()
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    getCartData()
  }, [location]);
  const [countdown, setCountdown] = useState(10);
  const [detectedLocation, setDetectedLocation] = useState("");
  const regions = [
    { name: "United Arab Emirates", code: "AE", published: true, url: "https://printmeup.ai/", title: 'UAE' },
    { name: "Pakistan", code: "PK", published: true, url: "https://pk.printmeup.ai/", title: 'Pakistan' },
    { name: "Saudi Arabia", code: "SA", info: "Coming Soon", published: false, title: 'Saudi Arabia' },
    { name: "USA", code: "US", info: "Coming Soon", published: false, title: 'USA' },
  ];
  const [autoRedirect, setAutoRedirect] = useState(true)
  useEffect(() => {
    if (!region) return;
    console.log(region, 'regionregionregion');

    setCountdown(10);
    console.log("Countdown started for region:", region);

    const intervalId = setInterval(() => {
      setCountdown((prev) => {
        console.log("Countdown tick:", prev);
        if (prev === 1) {
          clearInterval(intervalId);
          console.log("Countdown finished");

          if (autoRedirect) {
            console.log("Auto redirecting to:", detectedLocation);
            console.log("Redirecting...");
            setRegion(false)
            handleRedirect(detectedLocation);
          } else {
            console.log("AutoRedirect is false — skipping redirect");
          }

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      console.log("Cleaning up interval");
      clearInterval(intervalId);
    };
  }, [region]);

  // useEffect(() => {


  //   const isPublished = regions.some(
  //     (region) =>
  //       region.published &&
  //       (region?.name?.toUpperCase() === detectedLocation?.toUpperCase() ||
  //         region?.code?.toUpperCase() === detectedLocation?.toUpperCase())
  //   );

  //   setAutoRedirect(isPublished);
  // }, [detectedLocation]);



  const handleRedirect = async (region) => {
    console.log(`Redirecting to: ${region}`);
    console.log(`Redirecting to:`, region?.toLowerCase());
    console.log(`Redirecting to:`, regions);
    let find = regions.find((item => item?.name?.toLowerCase() == region?.toLowerCase()))
    console.log(find, 'find')
    // Example redirection logic:
    localStorage.setItem('region', region)
    window.location.href = find?.url;
    setRegion(false);
  };

  const handleStay = () => {
    setRegion(false);
  };
  console.log(getData());
  // → [{ code: 'AF', name: 'Afghanistan' }, { code: 'PK', name: 'Pakistan' }, ...]

  // Example usage:
  const countryNames = Object.fromEntries(getData().map(c => [c.code, c.name]));

  console.log(countryNames["PK"]); // Pakistan



  console.log(countryNames["PK"]); // Pakistan

  const location2 = useGeoLocation();
  useEffect(() => {
    console.log(location2, 'location2');

    if (!location2 || !location2.country && !location2.countryCode) return; // wait until location data is ready
    const countryFullName = new Intl.DisplayNames(['en'], { type: 'region' }).of(location2.country);
    console.log(countryFullName, 'countryFullName');

    const countryCode = location2.country || location2.countryCode;
    const countryName = countryFullName;

    console.log(countryCode, 'Detected country code');
    console.log(countryName, 'Detected country name');
    console.log(process.env.REACT_APP_COUNTRY, 'Detected country name');

    setDetectedLocation(countryName);

    if (countryName !== process.env.REACT_APP_COUNTRY) {
      const stored = localStorage.getItem('region');
      console.log(stored, 'stored');

      if (!stored) {
        setRegion(true);
        // localStorage.setItem('region', countryName);
      }
    }
    else {
      localStorage.setItem('region', process.env.REACT_APP_COUNTRY)
    }
  }, [location2?.country, location2?.countryCode]);

  useEffect(() => {
    console.log(process.env.REACT_APP_COUNTRY, 'getCountryCode()')
    setCode(getCountryCode())

  }, [process.env.REACT_APP_COUNTRY])



  return (
    <>
      <Dialog
        open={region}
        // onClose={() => setRegion(false)}
        fullWidth
        maxWidth="sm"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "blur(8px)",
            },
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: "#0C1427",
            boxShadow: "none",
            borderRadius: "12px",
            p: 2,
          },
        }}
      >
        {localStorage.getItem('region') && <IconButton
          onClick={() => setRegion(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "white",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
          }}
        >
          <CloseIcon />
        </IconButton>}
        <DialogContent>
          <Typography
            variant="h5"
            sx={{ mb: 2, textAlign: "center", fontWeight: "bold", color: "white" }}
          >
            Choose your region
          </Typography>

          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "gray", mb: 3 }}
          >
            We tailor content based on your location. You can change this anytime.
          </Typography>

          {autoRedirect && <Box
            sx={{
              backgroundColor: "#101a33",
              p: 2,
              borderRadius: "10px",
              mb: 3,
              textAlign: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Detected location: {detectedLocation}
            </Typography>
            <Typography sx={{ color: "gray", mb: 2 }}>
              Redirecting you to {detectedLocation} in {countdown}s
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                variant="contained"
                onClick={() => handleRedirect(detectedLocation)}
                sx={{
                  background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)",
                  color: "#0F172A",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  textTransform: "none",
                  px: 3,
                }}
              >
                Go now
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  localStorage.setItem('region', process.env.REACT_APP_COUNTRY)
                  setRegion(false)
                }}
                sx={{
                  color: "white",
                  borderColor: "white",
                  borderRadius: "10px",
                  textTransform: "none",
                  px: 3,
                }}
              >
                Stay here
              </Button>
            </Box>
          </Box>}

          <Typography
            sx={{ textAlign: "center", color: "gray", mb: 2, fontSize: 14 }}
          >
            Or pick a region
          </Typography>

          <Grid container spacing={2}>
            {regions?.map((region) => (
              <Grid item xs={6} key={region.code}>
                <Button
                  fullWidth
                  onClick={() => {
                    if (region?.published) {
                      handleRedirect(region.name);
                    }
                  }}
                  sx={{
                    backgroundColor: "#101a33",
                    color: "white",
                    borderRadius: "10px",
                    py: 1.5,
                    "&:hover": { backgroundColor: "#162447" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: {
                          xs: "0.7rem", // small screens
                          sm: "0.9rem",  // small tablets
                          md: "1rem",    // medium screens
                          lg: "1.1rem",  // large screens
                        },
                        textTransform: 'capitalize'
                      }}
                    >
                      {region.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: "gray",
                        textTransform: "capitalize",
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.75rem",
                          md: "0.85rem",
                          lg: "0.9rem",
                        },
                      }}
                    >
                      {!region.info ? region.code : ""} {region.info ? `(${region.info})` : ""}
                    </Typography>
                  </Box>
                </Button>
              </Grid>
            ))}

          </Grid>

          <Typography
            sx={{
              textAlign: "center",
              color: "gray",
              mt: 3,
              fontSize: 12,
            }}
          >
            We use your approximate IP location to suggest a region. No precise
            location data is stored.
          </Typography>
        </DialogContent>
      </Dialog>
      {currentState && <SignInModal
        open={open2}
        handleClose={handleClose2}
        screen={currentState}
        handleGoogleLogin={handleGoogleLogin}
        getCartData={getCartData}
      />}
      <HideOnScroll>
        <Box
          sx={{
            backgroundColor: scrolled ? "#0F172A " : "transparent",
            zIndex: "999 !important",
            position: "fixed",
            width: "100%",
          }}
        >
          <Container sx={{ maxWidth: "1920px !important", px: { md: "70px" }, py: "20px" }}>
            <Toolbar
              sx={{
                flexDirection: {
                  lg: "row",
                  md: "row",
                  sm: "row-reverse",
                  xs: "row-reverse",
                },
                justifyContent: "space-between",
                gap: 5,
              }}
              disableGutters
            >
              <CardMedia
                component={"img"}
                src={Images.mainlogo}
                sx={{
                  width: "160px",
                  objectFit: "contain",
                  display: { xs: "none", md: "block", cursor: "pointer" },
                  marginBottom: '14px'
                }}
                onClick={() => navigate("/")}
              />

              <Box
                sx={{
                  display: { xs: "flex", md: "none" },
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: "15px",
                }}
              >

                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenDrawer}
                  sx={{
                    color: Colors.primary,
                  }}
                >
                  <MenuIcon />
                </IconButton>

                {!User && <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="account of current user"
                  aria-controls="profile-menu"

                  // aria-haspopup="true"
                  onClick={(event) => {
                    setAutoRedirect(false)
                    setRegion(true)
                  }}
                >
                  {console.log(process.env.REACT_APP_COUNTRY)}
                  <SmallBadge badgeContent={getCountryCode(process.env.REACT_APP_COUNTRY)} sx={{ fontSize: '7px', color: 'white', mr: 1 }}>
                    <LanguageIcon sx={{ color: 'white', fontSize: '25px' }} />
                  </SmallBadge>
                </IconButton>}


                {!User ? (
                  <>
                    {" "}
                    <Box
                      sx={{
                        display: {
                          lg: "flex",
                          md: "flex",
                          sm: "none",
                          xs: "none",
                        },
                      }}
                    >
                      <PrimaryButton
                        title={"Login"}
                        sx={{
                          borderRadius: "12px",
                          padding: "7px 30px !important",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          setCurrentState("login");
                          setOpen2(true);

                        }}
                      />
                      <PrimaryButton
                        title={"SignUp"}
                        color={"#0F172A"}
                        sx={{
                          borderRadius: "12px",
                          padding: "7px 30px !important",
                          fontWeight: "bold",
                        }}
                        backgorundColor={"#0EA5EA"}
                        onClick={() => {
                          setCurrentState("register");
                          setOpen2(true);

                        }}
                      />

                    </Box>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",

                    }}
                  >
                    <IconButton
                      edge="end"
                      color="inherit"
                      aria-label="account of current user"
                      aria-controls="profile-menu"

                      // aria-haspopup="true"
                      onClick={(event) => {
                        setAutoRedirect(false)
                        setRegion(true)
                      }}
                    >
                      <SmallBadge badgeContent={process.env.REACT_APP_COUNTRY ? getCountryCode(process.env.REACT_APP_COUNTRY) : ''} sx={{ fontSize: '7px', color: 'white' }}>
                        <LanguageIcon sx={{ color: 'white', fontSize: '25px' }} />
                      </SmallBadge>
                    </IconButton>
                    &nbsp;&nbsp;  &nbsp;
                    {cartItems?.length > 0 ? (
                      <Box component={"div"} onClick={() => navigate("/cart")}>
                        {" "}
                        <SmallBadge badgeContent={""} color="primary">
                          {" "}
                          <ShoppingCartIcon onClick={() => navigate("/cart")}
                            sx={{ cursor: "pointer", color: "white" }}
                          />
                        </SmallBadge>
                      </Box>
                    ) : (
                      <Box>
                        <ShoppingCartIcon onClick={() => navigate("/cart")}
                          sx={{ cursor: "pointer", color: "white" }}
                        />
                      </Box>
                    )}{" "}

                    <IconButton
                      edge="end"
                      color="inherit"
                      aria-label="account of current user"
                      aria-controls="profile-menu"
                      sx={{ display: { lg: 'flex', md: 'flex', sm: 'none', xs: 'none' } }}
                      // aria-haspopup="true"
                      onClick={(event) => handleClick(event)}
                    >
                      <Avatar
                        alt={user?.name}
                        src={user?.picture ? process.env.REACT_APP_IMAGE_BASE_URL + user?.picture : userData?.photoUrl}
                        sx={{ width: (!user?.picture && !userData?.photoUrl) ? 30 : 30, height: (!user?.picture && !userData?.photoUrl) ? 30 : 30 }}
                      >
                        {(!user?.picture && !userData?.photoUrl) ? user?.name?.charAt(0).toUpperCase() : ''}
                      </Avatar>
                    </IconButton>

                    {dropdown && (
                      <Menu
                        id="profile-menu"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleProfile}>Profile</MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                      </Menu>
                    )}
                  </div>
                )}
                <Drawer
                  anchor="right"
                  open={open}
                  onClose={handleCloseDrawer}
                  PaperProps={{
                    sx: {
                      width: "60%",
                      background: Colors.backgroundColor1,
                    },
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                    <IconButton sx={{ textAlign: 'right' }} onClick={() => handleCloseDrawer()}><CloseIcon sx={{ color: "white" }} /></IconButton>
                  </Box>
                  <List sx={{ pt: '20px' }}>
                    {pages.map((item, ind) => (
                      <ListItem
                        key={ind}
                        button
                        onClick={() => {
                          setOpen(false);
                          if (item?.url) {
                            if (location.pathname === '/') {
                              window.scrollTo(0, 0);
                            }
                            navigate(item.url);
                          } else {
                            const pathname = window.location.pathname;
                            console.log(pathname);
                            if (pathname != "/") {
                              navigate("/");

                              setTimeout(() => {
                                scrollToId(item?.id);
                              }, 1000);
                            }
                            scrollToId(item?.id);
                          }
                        }}
                      >
                        <ListItemText
                          sx={{ color: Colors.white }}
                          primary={item.name}
                        />
                      </ListItem>
                    ))}

                    {!User ? (
                      <ListItem>
                        {" "}
                        <Box sx={{ display: "flex", gap: 2, flexWrap: 'wrap' }}>

                          <PrimaryButton
                            sx={{
                              borderRadius: "12px",
                              padding: "7px 35px !important",
                              fontWeight: "bold"
                            }}
                            title={"Login"}
                            onClick={() => {
                              setCurrentState("login");
                              setCurrentState("login");
                              setCurrentState("login");
                              setOpen2(true);
                              setCurrentState("login");

                            }}
                          />
                          <PrimaryButton
                            className={'singupbtn'}
                            sx={{
                              borderRadius: "12px",
                              padding: "7px 30px !important",
                              fontWeight: "bold"
                            }}
                            title={"Signup"}
                            color={"#0F172A"}
                            backgorundColor={"#0EA5EA"}
                            onClick={() => {
                              setOpen2(true);
                              setCurrentState("register");
                            }}
                          />


                        </Box>
                      </ListItem>
                    ) : (
                      <div style={{ marginTop: "-5px" }}>
                        <List sx={{ pt: 1, pb: 0 }}>
                          <ListItem>
                            <ListItemText
                              button
                              onClick={handleProfile}
                              sx={{
                                color: Colors.white,
                                cursor: "pointer",
                                mb: "0px",
                                mt: "0px",
                              }}
                              primary={"My Account"}
                            />
                          </ListItem>
                        </List>
                        <List sx={{ pt: 1 }}>
                          <ListItem>
                            <ListItemText
                              button
                              onClick={handleLogout}
                              sx={{
                                color: Colors.white,
                                cursor: "pointer",
                                mt: "0px",
                                mb: "0px",
                              }}
                              primary={"Logout"}
                            />
                          </ListItem>
                        </List>
                      </div>
                    )}
                  </List>
                </Drawer>
              </Box>
              <Link to="/">
                <CardMedia
                  component={"img"}
                  src={Images.mainlogo}
                  sx={{
                    width: "160px",
                    objectFit: "contain",
                    display: { xs: "flex", md: "none" },
                    mr: 1,
                    cursor: "pointer"
                  }}
                />
              </Link>
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "none", md: "flex" },
                  justifyContent: "flex-start",
                  gap: 5,
                }}
              >
                {pages.map((page) => {
                  const isActive = active === page.id;
                  return (

                    <Box
                      button
                      onClick={() => {
                        if (page?.url) {
                          if (location.pathname === '/') {
                            window.scrollTo(0, 0); // Scroll to top if current page is home
                          }
                          navigate(page.url);
                        } else {
                          const pathname = window.location.pathname;
                          console.log(pathname);
                          if (pathname != "/") {
                            navigate("/");

                            setTimeout(() => {
                              scrollToId(page?.id);
                            }, 1000);
                          }
                          scrollToId(page?.id);
                        }
                      }}
                    >
                      <Button
                        key={page}
                        onClick={() => {
                          setActive(page.id)
                          handleCloseDrawer();

                        }}
                        sx={{
                          my: 2,
                          color: "white",
                          display: "block",
                          color: isActive ? "#0EA5EA" : Colors.white,
                          textTransform: "capitalize",
                        }}
                      >
                        {page.name}
                      </Button>
                    </Box>
                  )

                })}
              </Box>
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  gap: "16px",
                }}
              >
                {!User ? (
                  <>
                    <IconButton
                      edge="end"
                      color="inherit"
                      aria-label="account of current user"
                      aria-controls="profile-menu"

                      // aria-haspopup="true"
                      onClick={(event) => {
                        setAutoRedirect(false)
                        setRegion(true)
                      }}
                      sx={{ pr: 1.5 }}
                    >
                      <SmallBadge badgeContent={getCountryCode(process.env.REACT_APP_COUNTRY)} sx={{ fontSize: '7px', color: 'white' }}>
                        <LanguageIcon sx={{ color: 'white', fontSize: '25px' }} />
                      </SmallBadge>
                    </IconButton>

                    <PrimaryButton
                      className={'singupbtn'}
                      title={"Signup"}
                      color={"#0F172A"}
                      backgorundColor={"#0EA5EA"}
                      sx={{
                        ":hover": {
                          color: "#0F172A",
                          backgroundColor: "#0EA5EA",
                        },
                        borderRadius: "12px",
                        padding: "7px 30px !important",
                        fontWeight: "bold",
                      }}
                      borderRadius={"0px"}
                      onClick={() => {
                        setCurrentState("register");
                        setOpen2(true);

                      }}
                    />
                    <PrimaryButton
                      title={"Login"}
                      sx={{
                        border: "3px solid #0EA5EA",
                        ":hover": {
                          borderWidth: "3px",
                        },
                        borderRadius: "12px",
                        padding: "7px 30px !important",
                        fontWeight: "bold",
                      }}
                      color={"#0EA5EA"}
                      borderRadius={"0px"}
                      onClick={() => {
                        setCurrentState("login");
                        setCurrentState("login");
                        setCurrentState("login");
                        setOpen2(true);
                        setCurrentState("login");
                      }}
                    />

                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",

                    }}
                  >
                    <IconButton
                      edge="end"
                      color="inherit"
                      aria-label="account of current user"
                      aria-controls="profile-menu"

                      // aria-haspopup="true"
                      onClick={(event) => {
                        setAutoRedirect(false)
                        setRegion(true)
                      }}
                    >
                      <SmallBadge badgeContent={getCountryCode(process.env.REACT_APP_COUNTRY)} sx={{ fontSize: '7px', color: 'white' }}>
                        <LanguageIcon sx={{ color: 'white', fontSize: '27px' }} />
                      </SmallBadge>
                    </IconButton>
                    &nbsp;&nbsp;  &nbsp;
                    {cartItems?.length > 0 ? (
                      <Box component={"div"} >
                        {" "}
                        <SmallBadge badgeContent={""} color="primary">
                          {" "}
                          <ShoppingCartIcon onClick={() => navigate("/cart")}
                            sx={{ cursor: "pointer", color: "white" }}
                          />
                        </SmallBadge>
                      </Box>
                    ) : (
                      <Box>
                        <ShoppingCartIcon onClick={() => navigate("/cart")}
                          sx={{ cursor: "pointer", color: "white" }}
                        />
                      </Box>
                    )}{" "}
                    &nbsp;&nbsp;
                    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                      <div >

                        <IconButton
                          edge="end"
                          color="inherit"
                          aria-label="account of current user"
                          aria-controls="profile-menu"
                          sx={{ display: { lg: 'flex', md: 'flex', sm: 'none', xs: 'none' }, mt: '-8px' }}
                          onClick={(event) =>
                            setAnchorEl(anchorEl ? null : event.currentTarget)
                          }
                        >
                          <Avatar
                            alt={user?.name}
                            src={user?.picture ? process.env.REACT_APP_IMAGE_BASE_URL + user?.picture : userData?.photoUrl}
                            sx={{ width: (!user?.picture && !userData?.photoUrl) ? 30 : 30, height: (!user?.picture && !userData?.photoUrl) ? 30 : 30 }}
                          >
                            {(!user?.picture && !userData?.photoUrl) ? user?.name?.charAt(0).toUpperCase() : ''}
                          </Avatar>
                        </IconButton>

                        <Menu
                          id="profile-menu"
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleCloseDropdown}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                          keepMounted
                          sx={{
                            "& .MuiPaper-root": {
                              backgroundColor: "#101A33", // Background color for the dropdown
                              borderRadius: "0px", // Rounded corners
                              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Shadow effect
                              padding: "8px 0", // Padding for the menu
                              minWidth: "150px", // Minimum width
                              color: "#858a97",
                            },
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              navigate("/my-account", { state: "0" });
                              handleProfile()
                            }}
                            sx={{
                              "&:hover": {
                                textDecoration: "underline", // Underline on hover
                              },
                              fontSize: "15px",
                            }}
                          >
                            My Account
                          </MenuItem>
                          <MenuItem
                            onClick={() => { navigate("/my-account", { state: "3" }); handleClose() }}

                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              fontSize: "15px",
                            }}
                          >
                            My Address
                          </MenuItem>
                          <MenuItem
                            onClick={() => { navigate("/my-account", { state: "4" }); handleClose() }}

                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              fontSize: "15px",
                            }}
                          >
                            My Orders
                          </MenuItem>
                          <MenuItem
                            onClick={() => { navigate("/my-account", { state: "1" }); handleClose() }}
                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              fontSize: "15px",
                            }}
                          >
                            My Library
                          </MenuItem>
                          <MenuItem
                            onClick={() => { navigate("/my-account", { state: "2" }); handleClose() }}
                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              fontSize: "15px",
                            }}
                          >
                            My Designs
                          </MenuItem>
                          <MenuItem
                            onClick={() => { handleLogout(); handleClose() }}
                            sx={{
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              fontSize: "15px",
                            }}
                          >
                            Logout
                          </MenuItem>
                        </Menu>
                      </div>
                    </ClickAwayListener>
                  </div>
                )}
              </Box>
            </Toolbar>
          </Container>
        </Box>
      </HideOnScroll>
    </>
  );
}

export default Header;
